import { UseFormReturn } from 'react-hook-form';
import React, { FC, useCallback, useRef } from 'react';
import { FORM_FIELDS } from '../../../../../../constants';
import { MonthInput } from '../../../../../landing.common';
import { FocusedFieldWithAlert } from '../../common';

interface LastExperienceProps {
    form: UseFormReturn;
}

export const LastExperienceMobileField: FC<LastExperienceProps> = ({ form, ...props }) => {
    const {
        watch,
        setValue,
        formState: { errors, dirtyFields: _ },
    } = form;

    const wrapprerRef = useRef<HTMLDivElement | null>(null);

    const [monthValue, yearValue] = watch([
        FORM_FIELDS.LAST_EXPERIENCE_START_MONTH,
        FORM_FIELDS.LAST_EXPERIENCE_START_YEAR,
    ]);

    const onBlur: React.FocusEventHandler<HTMLInputElement> = async (event) => {
        event.stopPropagation();
        const normalizedValue = event.target.value.replace(/[^\d.]/g, '');
        const [monthVal, yearVal] = normalizedValue.split('.');
        setValue(FORM_FIELDS.LAST_EXPERIENCE_START_YEAR, yearVal, { shouldValidate: false });
        setValue(FORM_FIELDS.LAST_EXPERIENCE_START_MONTH, monthVal, { shouldValidate: false });

        if (wrapprerRef.current) {
            wrapprerRef.current.dispatchEvent(
                new CustomEvent('manualBlur', {
                    bubbles: true,
                    detail: {
                        fields: [FORM_FIELDS.LAST_EXPERIENCE_START_YEAR, FORM_FIELDS.LAST_EXPERIENCE_START_MONTH],
                    },
                }),
            );
        }
    };

    const monthAndYear = useCallback((monthValue?: string, yearValue?: string) => {
        const fields = {
            [FORM_FIELDS.LAST_EXPERIENCE_START_MONTH]: {
                placeholder: '__',
                currentValue: monthValue || '',
            },
            [FORM_FIELDS.LAST_EXPERIENCE_START_YEAR]: {
                placeholder: '____',
                currentValue: yearValue || '',
            },
        };

        return [FORM_FIELDS.LAST_EXPERIENCE_START_MONTH, FORM_FIELDS.LAST_EXPERIENCE_START_YEAR]
            .map((fieldName) => {
                const { currentValue, placeholder } = fields[fieldName];
                if (!currentValue) {
                    return placeholder;
                }
                return currentValue.replace(/[^\d.]/g, '');
            })
            .join('.');
    }, []);

    return (
        <FocusedFieldWithAlert
            showAlert
            field={
                <MonthInput
                    errorMessage={
                        errors[FORM_FIELDS.LAST_EXPERIENCE_START_YEAR]?.message ||
                        errors[FORM_FIELDS.LAST_EXPERIENCE_START_MONTH]?.message
                    }
                    value={monthAndYear(monthValue, yearValue)}
                    onBlur={onBlur}
                    {...props}
                />
            }
            ref={wrapprerRef}
            alert={
                'Укажите только месяц и год. Дата начала работы важна, так как некоторые банки выдают кредиты при стаже от 3-6 месяцев на\u00A0последнем месте'
            }
        />
    );
};
